/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { PieChart, Pie, Cell, Legend } from 'recharts';

function totalizeValues(data1, data2) {
  const Receitas = data1.reduce((total, item) => total + item.Receitas, 0);
  const Despesas = data1.reduce((total, item) => total + item.Despesas, 0);
  const totalValor = data2.reduce((total, item) => total + item.Valor, 0);
  const balanco = Despesas + totalValor;
  return [
    { name: 'Receitas', value: Receitas },
    { name: 'Total Despesas', value: balanco },
  ];
}

const COLORS = ['#0088FE', '#00C49F'];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="black"
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
      fontSize={12}
    >
      {`${(percent * 100).toFixed(2)}%`}
    </text>
  );
};

// eslint-disable-next-line react/prop-types
function App({ dados1, dados2 }) {
  const data = totalizeValues(dados1, dados2);
  return (
    <PieChart width={400} height={300}>
      <Pie
        data={data}
        cx={200}
        cy={130}
        labelLine={false}
        label={renderCustomizedLabel}
        outerRadius={130}
        fill="#8884d8"
        dataKey="value"
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie>
      <Legend />
    </PieChart>
  );
}

App.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  dados1: PropTypes.array.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  dados2: PropTypes.array.isRequired,
};

export default App;
